import { jsx as _jsx } from "react/jsx-runtime";
import { OverlayCircularProgress } from "@ploy-ui/core";
import { styled } from "@material-ui/core";
import { useThemeComponent } from "@ploy-ui/tenants";
const DarkOverlayCircularProgress = styled(OverlayCircularProgress)({
    background: "rgba(0,0,0,0.3)"
});
export const LoadingOverlay = (props) => {
    const { pending } = props;
    const loadingComponent = useThemeComponent("LoadingOverlay");
    return (loadingComponent?.(pending) || (_jsx(DarkOverlayCircularProgress, { pending: pending })));
};
export default LoadingOverlay;
//# sourceMappingURL=LoadingOverlay.js.map